// eventColors.js

const textOnHover = ' sm:hover:text-zinc-100 sm:dark:hover:text-zinc-900';

export default function getEventColor(eventName, showNotes) {
  // check if eventName has `camp" in it
  if (eventName.toLowerCase().includes("trial")) return `border-amber-600 dark:border-amber-400 ${!showNotes && 'sm:hover:bg-amber-600 sm:dark:hover:bg-amber-400' + textOnHover}`;
  if (eventName.toLowerCase().includes("internal")) return `border-teal-600 dark:border-teal-400 ${!showNotes && 'sm:hover:bg-teal-600 sm:dark:hover:bg-teal-400' + textOnHover}`;
  if (eventName.toLowerCase().includes("camp")) return `border-rose-600 dark:border-rose-400 ${!showNotes && 'sm:hover:bg-rose-600 sm:dark:hover:bg-rose-400' + textOnHover}`;
  if (eventName.toLowerCase().includes("remote")) return `border-sky-600 dark:border-sky-400 ${!showNotes && 'sm:hover:bg-sky-600 sm:dark:hover:bg-sky-400' + textOnHover}`;
  if (eventName.toLowerCase().includes("in person")) return `border-pink-600 dark:border-pink-400 ${!showNotes && 'sm:hover:bg-pink-600 sm:dark:hover:bg-pink-400' + textOnHover}`;
  return `border-slate-300 dark:border-slate-800`;
}
